module.exports = __webpack_public_path__ + "static/25-WHY-DIGITAL-TRANSFORMATION-CAN-NO-LONGER-BE-IGNORED-cf8556f268290bff900cb826b01a9e7a.jpg";